export const getDayName = (): string => {
  const date = new Date();
  return date.toLocaleDateString(undefined, { weekday: "long" });
};
